import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import "./mcTranslations"
import Cookies from "js-cookie";

const queryParams = new URLSearchParams(window.location.search);
const clientId = queryParams.get("clientId");
const memberId = queryParams.get("memberId");

console.log("MirrorChat Init - Query Params:", { clientId, memberId });

if (clientId) {
  console.log("Setting clientId cookie:", clientId);
  Cookies.set("clientId", clientId, { path: '/' });
}
if (memberId) {
  console.log("Setting memberId cookie:", memberId);
  Cookies.set("memberId", memberId, { path: '/' });
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  // <React.StrictMode>
    <App />
  // </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
